import { Space } from '@billy/design-system'
import { ReactElement } from 'react'

import { InvoicingSettingsLoadErrorMessage } from '../../../../elements/InvoicingSettingsLoadErrorMessage'
import type { InvoicingSettingsSection } from '../../../../enums/invoicingSettingsSection'
import { ApplyColorToDocumentElements } from './elements/ApplyColorToDocumentElements'
import { DefaultColorPicker } from './elements/DefaultColorPicker'
import { DefaultFontSelector } from './elements/DefaultFontSelector'
import { DefaultInvoiceLogo } from './elements/DefaultInvoiceLogo'
import { LogoAndBrandingSettingsFormFieldsSkeletons } from './elements/LogoAndBrandingSettingsFormFieldsSkeletons'

interface LogoAndBrandingSettingsFormFieldsProps {
  hasFailedToLoad: boolean
  isLoading: boolean
  onRetry: () => Promise<unknown>
  // Only the settings modal passes it. The invoice editor renders the same fields and keeps its event names.
  trackingSection?: InvoicingSettingsSection
}

// The fields stay hidden until the settings document and the template have loaded. Showing them
// on a failed fetch would let an edit mark the form dirty, skip hydration, and save the defaults.
export const LogoAndBrandingSettingsFormFields = ({
  hasFailedToLoad,
  isLoading,
  onRetry,
  trackingSection,
}: LogoAndBrandingSettingsFormFieldsProps): ReactElement => {
  if (isLoading) {
    return <LogoAndBrandingSettingsFormFieldsSkeletons />
  }

  if (hasFailedToLoad) {
    return <InvoicingSettingsLoadErrorMessage onRetry={onRetry} />
  }

  return (
    <>
      <DefaultInvoiceLogo trackingSection={trackingSection} />
      <Space />
      <DefaultFontSelector trackingSection={trackingSection} />
      <Space />
      <DefaultColorPicker trackingSection={trackingSection} />
      <Space />
      <ApplyColorToDocumentElements trackingSection={trackingSection} />
    </>
  )
}
